import { useState } from "react";
import { X, Clock, CalendarCheck } from "lucide-react";
import { trackEvent } from "@/components/GoogleAnalytics";

const UrgencyBanner = () => {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) return null;

  const handleCTAClick = () => {
    trackEvent("urgency_banner_click", { category: "conversion", label: "limited_spots" });
    window.location.href = "/book";
  };

  return (
    <div className="bg-primary text-primary-foreground relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary/90 to-primary" />
      <div className="container mx-auto px-4 py-2.5 relative z-10">
        <div className="flex items-center justify-center gap-3 text-sm md:text-base">
          <Clock className="w-4 h-4 flex-shrink-0 animate-pulse" />
          <span className="font-medium">
            <span className="hidden sm:inline">🔥 Limited Availability — </span>
            Only <strong>3 spots left</strong> this month for new clients
          </span>
          <button
            onClick={handleCTAClick}
            className="bg-white/20 hover:bg-white/30 text-white font-semibold px-3 py-1 rounded-full text-xs md:text-sm transition-colors whitespace-nowrap"
          >
            <CalendarCheck className="w-3.5 h-3.5 inline mr-1" />
            Claim Your Spot
          </button>
          <button
            onClick={() => {
              setIsDismissed(true);
              trackEvent("urgency_banner_dismissed", { category: "engagement" });
            }}
            className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-white/10 rounded-full transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UrgencyBanner;
